import React from "react";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader } from "reactstrap";

import {
    store as associateStore,
    resetStore,
    setCheckModificationEffect,
    setIsAddPeripheralClicked,
} from "./store";

import { capitalize } from "@helpers/general";

import { MenuWrapperAssociate } from "../Kiosk/MenuWrapperAssociate/index";
import { setIsLoadingAssociateValidation } from "@components/VerticalLayout/store";

import "../index.css";
import {
    PERIPHERAL_TYPE_CASH_MANAGEMENT,
    PERIPHERAL_TYPE_MONETIC,
} from "@constants/index";

type PrintersPathsModalType = {
    setIsDeviceAssociateModalOpened: Function;
    isDeviceAssociateModalOpened: boolean;
    rowData: any;
    dataIsUpdated: boolean | number;
    setDataIsUpdated: Function;
    oneShop: boolean;
    selectedRows: any;
};

export default function DeviceAssociateModal({
    setIsDeviceAssociateModalOpened,
    isDeviceAssociateModalOpened,
    rowData,
    dataIsUpdated,
    setDataIsUpdated,
    oneShop,
    selectedRows,
}: PrintersPathsModalType) {
    const { t } = useTranslation();

    React.useEffect(() => {
        setCheckModificationEffect(false);
        setIsLoadingAssociateValidation(false);

        const validSelectedRows = selectedRows.filter(
            (elt: any) => elt[t("Application")] !== ""
        );
        const source =
            validSelectedRows.length === 1 ? validSelectedRows[0] : rowData;

        source?.subRows?.forEach((el: any) => {
            if (el.peripheralType === PERIPHERAL_TYPE_MONETIC) {
                const id = el.id_monetic;
                if (!associateStore.monetics.some((m: any) => m.Id === id)) {
                    associateStore.monetics.push({
                        ...el,
                        Id: id,
                        [t("Designation")]: el[t("Peripheral")],
                    });
                }
            }
            if (el.peripheralType === PERIPHERAL_TYPE_CASH_MANAGEMENT) {
                const id = el.peripheralId;
                if (
                    !associateStore.cashManagements.some(
                        (m: any) => m.Id === id
                    )
                ) {
                    associateStore.cashManagements.push({
                        ...el,
                        Id: id,
                        [t("Designation")]: el[t("Peripheral")],
                    });
                }
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const applicationNames =
        selectedRows.length > 1
            ? selectedRows
                  .map((el: any) => el.Application)
                  .filter(Boolean)
                  .join(",")
            : rowData.Application;

    return (
        <Modal
            centered
            backdrop="static"
            fade={false}
            scrollable
            className="modal-wrapper__clz modal-assoc__clz cmn_frm_popupAssociation"
            isOpen={isDeviceAssociateModalOpened}
        >
            <ModalHeader
                toggle={() => {
                    setIsAddPeripheralClicked(false);
                    setIsDeviceAssociateModalOpened!(
                        !isDeviceAssociateModalOpened
                    );
                    setDataIsUpdated(!dataIsUpdated);
                    resetStore();
                }}
            >
                <StyledH2>
                    {capitalize(
                        `${t(
                            "Associate a device with an application"
                        )} (${applicationNames})`
                    )}
                </StyledH2>
            </ModalHeader>
            <MenuWrapperAssociate
                rowData={rowData}
                setIsDeviceAssociateModalOpened={
                    setIsDeviceAssociateModalOpened
                }
                isDeviceAssociateModalOpened={isDeviceAssociateModalOpened}
                setDataIsUpdated={setDataIsUpdated}
                dataIsUpdated={dataIsUpdated}
                oneShop={oneShop}
                selectedRows={selectedRows}
            />
        </Modal>
    );
}
